export enum RoutePaths {
  // Community Paths
  COMMUNITY = '/community',
  COMMUNITY_INVITES = 'invites',
  COMMUNITY_PENDING = 'pending',
  COMMUNITY_MEMBERS = 'members',
  COMMUNITY_PARTNERS = 'partners',

  // Tasks Paths
  TASKS = '/tasks',

  // Activity Paths
  ACTIVITY = '/activity',

  // Files Paths
  FILES = '/files',

  // Notes Paths
  NOTES = '/notes',

  // Calls Paths
  CALLS = '/calls',

  // Record Paths
  RECORD = '/record',
  RECORD_HOME = 'home',
  RECORD_LINKED_RECORDS = 'linked-records',
  RECORD_TASKS = 'tasks',
  RECORD_ACTIVITY = 'activity',
  RECORD_CALLS = 'calls',
  RECORD_NOTES = 'notes',
  RECORD_FILES = 'files',

  // Account Settings Paths
  ACCOUNT_SETTINGS = '/account-settings',
  ACCOUNT_SETTINGS_PERSONAL_INFO = 'personal-info',
  ACCOUNT_SETTINGS_SECURITY = 'security',
  ACCOUNT_SETTINGS_PRIVACY = 'privacy',
  ACCOUNT_SETTINGS_PRIVACY_PROSPECTIVE_CONTACTS = 'prospective-contacts',
  ACCOUNT_SETTINGS_PRIVACY_CONTACTS = 'contacts',
  ACCOUNT_SETTINGS_PRIVACY_COMMUNITY_PARTNERS = 'community-partners',
  ACCOUNT_SETTINGS_NOTIFICATIONS = 'notifications',

  // Admin Settings Paths
  ADMIN_SETTINGS = '/admin-settings',
  ADMIN_SETTINGS_ACCOUNT = 'account',
  ADMIN_SETTINGS_ACCOUNT_ORGANIZATION = 'organization',
  ADMIN_SETTINGS_ACCOUNT_REPRESENTATIVES = 'representatives',
  ADMIN_SETTINGS_LOCATION_LIST = 'location-list',
  ADMIN_SETTINGS_LOCATION = 'location',
  ADMIN_SETTINGS_LOCATION_PUBLIC_PROFILE = 'public-profile',
  ADMIN_SETTINGS_LOCATION_HIGHLIGHTED_TAGS = 'highlighted-tags',
  ADMIN_SETTINGS_LOCATION_CUSTOM_FIELDS = 'custom-fields',
  ADMIN_SETTINGS_LOCATION_AUTO_TAGGING = 'auto-tagging',
  ADMIN_SETTINGS_STAFF = 'staff',
  ADMIN_SETTINGS_RECORDS = 'records',
  ADMIN_SETTINGS_PERMISSION_SETS_LIST = 'permission-sets-list',
  ADMIN_SETTINGS_PERMISSION_SETS = 'permission-sets',
  ADMIN_SETTINGS_PERMISSION_SETS_DETAILS = 'details',
  ADMIN_SETTINGS_PERMISSION_SETS_CUSTOM_FIELD_VISIBILITY = 'custom-field-visibility',
  ADMIN_SETTINGS_PERMISSION_SETS_STAFF = 'staff',
  ADMIN_SETTINGS_EXCLUSIVE_TAGS = 'exclusive-tags',
  ADMIN_SETTINGS_STAGES = 'stages',
  ADMIN_SETTINGS_CALLS = 'calls',
  ADMIN_SETTINGS_CALLS_DISPOSITIONS = 'dispositions',
  ADMIN_SETTINGS_CALLS_DISPOSITIONS_ADD = 'add',
  ADMIN_SETTINGS_CALLS_PURPOSES = 'purposes',
  ADMIN_SETTINGS_INCIDENTS = 'incidents',
  ADMIN_SETTINGS_INCIDENTS_SOURCE = 'source',
  ADMIN_SETTINGS_INCIDENTS_ACTION_TAKEN = 'action-taken',
  ADMIN_SETTINGS_FILE_CATEGORIES = 'file-categories',
  ADMIN_SETTINGS_CUSTOM_FIELDS = 'custom-fields',
  ADMIN_SETTINGS_CUSTOM_FIELDS_CONTROL = 'custom-fields-control',
  ADMIN_SETTINGS_CUSTOM_FIELDS_CONTROL_DATA_TYPE = 'data-type',
  ADMIN_SETTINGS_CUSTOM_FIELDS_CONTROL_FIELD_DETAILS = 'field-details',
  ADMIN_SETTINGS_CUSTOM_FIELDS_CONTROL_RECORD_VISIBILITY = 'record-visibility',
  ADMIN_SETTINGS_CUSTOM_FIELDS_CONTROL_FIELD_LEVEL_SECURITY = 'field-level-security',
}
